// 恢复欠货和置换欠货
export default [
  // 欠货申请列表
  {
    path: "oweReback/oweRebackList",
    name: "OweRebackList",
    component: () => import("../pages/oweReback/oweRebackList.vue"),
    meta: {
      title: "恢复欠货列表",
    },
  },

  // 置换记录
  {
    path: "oweReback/exChangeList",
    name: "ExChangeList",
    component: () => import("../pages/oweReback/exChangeList.vue"),
    meta: {
      title: "置换欠货列表",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/oweReback.js